import React, { Component } from 'react';
import { reduxForm, FieldArray, Field } from 'redux-form';
import moment from 'moment';
import Countdown from 'react-countdown-now';

class RoomForm extends Component {
  render() {
    const { data, handleSubmit, onCancel } = this.props;

    let fields = new Array();
    // console.log("Free size", data.freeSize)
    for (let i=0; i<parseInt(data.freeSize); i++) {
      fields.push(<Field key={i} name={`roomer${i}`}
        component="input"
        className="rooms-form-input"
        pattern="[0-9]{6}"
        title="Indeks w formacie 000000"
        placeholder="Indeks" />)
    }

    return (
      <div className="rooms-form-wrapper">
        <div
          className="rooms-form-container">
          <Countdown
            date={moment(Date.parse(data.endTime)).format()}
            renderer={({minutes, seconds}) =>
              (<p className="rooms-form-timer">Pozostały czas
                <span> {minutes}:{seconds}</span>
              </p> )
            }
          />
          <form
            onSubmit={handleSubmit}
            className="rooms-form"
          >
          {data.roomers.length !== 0 &&
            <div>
              <p>Zapisani:</p>
              <ul>
              {
                data.roomers.map(roomer => <li key={roomer.index}>{roomer.index} - {roomer.name}.</li> )
              }
              </ul>
            </div>
          }
          {fields.length !== 0 &&
            <div>
              <p>Wpisz:</p>
              {
                fields.map(field => field)
              }
            </div>
          }
          { fields.length !==0 && <button type="submit" className="rooms-btn" >Zaktualizuj pokój</button>}
          <button
            type="button"
            className="rooms-btn--delete"
            onClick={onCancel}>Powrót bez zapisywania</button>
          </form>
        </div>
      </div>
    )
  }
};

export default reduxForm({
  form: 'roomToTake'
})(RoomForm);



// WEBPACK FOOTER //
// ./src/modules/User/components/RoomForm.js